import { render, staticRenderFns } from "./Infou.vue?vue&type=template&id=3358dbe8"
import script from "./Infou.vue?vue&type=script&lang=js"
export * from "./Infou.vue?vue&type=script&lang=js"
import style0 from "./Infou.vue?vue&type=style&index=0&id=3358dbe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports